import React, { useEffect, useRef } from 'react';
import { generateRandomColors } from '../../../../../../../../../../utils';
import Chart from 'chart.js/auto';
import './style.scss';

const PieDrilldown = ({ taskData }) => {
    const modalChartRef = useRef(null);

    useEffect(() => {
        if (modalChartRef.current && taskData && taskData.length > 0) {
            const sortedData = taskData.sort((a, b) => b.count - a.count);
            const values = sortedData.map(ele => ele.count);
            const labels = sortedData.map(ele => ele.taskName);
            const dynamicColors = Array.from({ length: values.length }, () => generateRandomColors());

            const modalChartCtx = modalChartRef.current.getContext('2d');
            const modalChart = new Chart(modalChartCtx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: dynamicColors,
                        borderColor: dynamicColors,
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        autoPadding: true
                    },
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return context.label + ': ' + context.formattedValue;
                                }
                            }
                        },
                        legend: {
                            display: true,
                            position: 'right',

                            labels: {
                                usePointStyle: true,
                                padding: 10,
                                generateLabels: function (chart) {
                                    const data = chart.data;

                                    if (data.labels.length && data.datasets.length) {
                                        return data.labels.map(function (label, i) {
                                            const dataset = data.datasets[0];
                                            return {
                                                text: label,
                                                fillStyle: '#100F0F',
                                                strokeStyle: dataset.borderColor[i],
                                                lineWidth: 3,
                                                pointStyle: 'circle',
                                                fontColor: 'white',
                                                weight: 140,
                                                spacing: 10,
                                            };
                                        });
                                    }
                                    return [];
                                },
                            },
                        },
                    }
                }
            });

            return () => {
                modalChart.destroy();
            };
        }
    }, [taskData]);

    return (
        <div>
            <div className='drilled-pie'>
                <canvas ref={modalChartRef}></canvas>
            </div>
        </div>
    )
}

export default PieDrilldown
